


























































































import { chunk } from 'lodash'
import { mapGetters } from 'vuex'
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'

import { Profile } from '@/store/builder/types'
import { App } from '@/services/types'
import WithBuilderStubProperties from '@/mixins/WithBuilderStubProperties'

import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDescription from '@/components/builder/BuilderDescription.vue'
import BuilderColorPicker from '@/components/builder/BuilderColorPicker.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderDeviceProfileStub from '@/components/builder/BuilderDeviceProfileStub.vue'
import BuilderColorSlider from '@/components/builder/BuilderColorSlider.vue'
import AppHeader from '@/components/app/AppHeader.vue'
import AppFooter from '@/components/app/AppFooter.vue'
import DescriptionMobileMenu from '@/components/DescriptionMobileMenu.vue'

@Component({
  components: {
    BuilderColorSlider,
    BuilderButton,
    CommonButton,
    BuilderTooltip,
    BuilderSidebar,
    BuilderColorPicker,
    BuilderDescription,
    BuilderDefaultContainer,
    BuilderDeviceProfileStub,
    AppHeader,
    AppFooter,
    DescriptionMobileMenu
  },
  computed: {
    ...mapGetters('builder', { profile: 'getProfile', app: 'getApp' }),
  },
  created() {
    this.$store.dispatch('app/changeVisibilityMenu', true)
  }
})
export default class BuilderCreate extends Mixins(WithBuilderStubProperties) {
  @Prop({ default: true, type: Boolean }) loaded!: boolean

  processing = false

  app!: App | null

  profile!: Profile

  activeIndex = 0

  isSliderColor = false

  sliderColor = '#779DE9'

  pickerColor = '#779DE9'

  colors = [
    '#779DE9',
    '#27e2cc',
    '#A7A7A7',
    '#6A6A6A',
    '#DC61B2',
    '#EFDA1E',
    '#972ABD',
    '#BC6AE2',
    '#95E977',
    '#E9777E',
    '#E4AF70',
    '#A1AFCA',
    '#0757FA',
    '#8777E9',
    '#E2C1AE',
    '#FF3D00',
    '#E99A00',
    '#00DD31',
  ]
  viewMode = false

  get color(): string {
    return this.isSliderColor ? this.sliderColor : this.pickerColor
  }

  @Watch('pickerColor', { immediate: true })
  onPickerColorChange(): void {
    this.isSliderColor = false
  }

  @Watch('sliderColor', { immediate: true })
  onSliderColorChange(): void {
    this.isSliderColor = true
  }

  @Watch('profile.color', { immediate: true })
  onProfileColorChange(color: string | undefined): void {
    if (!color) {
      this.pickerColor = '#779DE9'
    } else if (this.colors.includes(color)) {
      this.pickerColor = color
    } else {
      this.sliderColor = color
    }
  }

  get chunkedColors(): string[][] {
    return chunk(this.colors, 18)
  }

  async onNextClick(): Promise<void> {
    this.processing = true

    try {
      await this.$store.dispatch('builder/setProfileAppColor', {
        color: this.color,
      })

      await this.$router.push({
        name: 'profile.page_name',
        params: this.app ? { id: String(this.app.id) } : {},
      })
    } catch ({ message }: unknown) {
      this.$toasted.error(String(message))
    }

    this.processing = false
  }
  handlerClickBtnCloseMenu(): void {
    this.$store.dispatch('app/changeVisibilityMenu', false)
  }
}
